module.exports = __webpack_public_path__ + "static/media/client-logo-31.1bcf0384.jpg";